import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { pageResetMiddleWare, zodOptionalIdArray, zodPage, zodSort } from 'routes/routeUtils';
import { z } from 'zod';

export const groupTradesRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/trades',
  validateSearch: z.object({
    tab: z
      .enum([
        'ongoing',
        'upcoming',
        'over',
        'with_participation_to_validate',
        'awaiting_group_decision',
      ])
      .default('ongoing'),
    month: z.number().optional(),
    year: z.number().optional(),
    tagIds: zodOptionalIdArray,
    search: z.string().optional(),
    sort: zodSort(['kind']),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/group/Trades/GroupTradesPage/GroupTradesPage').then((d) => d.Route));
